module.exports = "<p>\n  suggestion-history works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/history/suggestion-history/suggestion-history.component.html
// module id = ./src/app/modules/history/suggestion-history/suggestion-history.component.html
// module chunks = main